import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledInputContainer = styled.div`
  display: flex;
  padding: 1em;
  background-color: ${colours.Shades.TintBlue10};
  margin-bottom: 1rem;
  justify-content: space-between;
`;

export const StyledTotalContainer = styled.div`
  display: flex;
  padding: 1em;
  background-color: ${colours.Shades.TintBlue10};
  margin-bottom: 1rem;
  justify-content: space-between;
  font-weight: bold;
`;

export const StyledLabel = styled.span`
  display: flex;
  width: 100%;
  font-size: 12px;
`;

export const StyledInputWrapper = styled.div`
  & + & {
    margin-left: 1em;
  }

  input {
    width: auto;
    height: 35px;
    font-size: 13px;

    &:disabled {
      border: 1px solid transparent;
      background: transparent;
      font-weight: bold;
    }
  }
`;

export const StyledFormFooter = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledButtonGroup = styled.div`
  button + button {
    margin-left: 15px;
  }
`;

export const StyledWarningMessage = styled.p`
  margin-left: 15px;
`;

export const StyledErrorMessage = styled.p`
  margin-top: 0;
  width: 100%;
  color: ${colours.Messaging.ErrorRed};
`;
